module.exports = __webpack_public_path__ + "static/media/Machinereiniging.d3b33a59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Machinereiniging.jpg
// module id = 322
// module chunks = 0